<template>
  <span class="file-text-outlined-icon" :style="iconStyle" aria-hidden="true">
    <!-- 与 Ant Design FileTextOutlined 一致（项目未装 @ant-design/icons-vue，用内联 SVG） -->
    <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
      <path
        d="M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'FileTextOutlinedIcon',
  props: {
    size: { type: [Number, String], default: 16 },
  },
  computed: {
    iconStyle() {
      const px = typeof this.size === 'number' ? `${this.size}px` : this.size
      return { fontSize: px }
    },
  },
}
</script>

<style scoped>
.file-text-outlined-icon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}
</style>
